var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"variant":"danger","show":_vm.formServerErrors.length !== 0,"dismissible":""},on:{"dismissed":function($event){_vm.formServerErrors = null}}},_vm._l((_vm.formServerErrors),function(error,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(error.msg)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }